/**
 * Агрегатные ключи эмоций и *теги* в тексте — как в Unity ControlHerGameplayController.emotionKeywords.
 * Первое совпадение по порядку DIALOGUE_AGGREGATE_EMOTION_KEYS (как перебор словаря в C#).
 */

/** Унификация «звёздочек» из типографики / Unicode → ASCII * (иначе *happy* не матчится). */
export function normalizeForDialogueEmotionTags(text) {
  return String(text || '')
    .replace(/\uFF0A/g, '*') // ＊ fullwidth
    .replace(/\u2217/g, '*') // ∗ asterisk operator
    .replace(/\uFE61/g, '*') // ﹡ small asterisk
    .replace(/\u2042/g, '*'); // ⁂ asterism
}

export const DIALOGUE_AGGREGATE_EMOTION_KEYS = [
  'Blush',
  'PlayfulYes',
  'OverwhelmedBlush',
  'Shocked',
  'Confusion',
  'PensiveBlush',
  'CuteShyYes'
];

/** @type {Record<string, string[]>} */
export const DIALOGUE_AGGREGATE_EMOTION_KEYWORDS = {
  Blush: ['*смущена*', '*embarrassed*', '*shy*', '*blush*'],
  PlayfulYes: ['*радостно*', '*хихиканье*', '*giggle*', '*happy*', '*playful*'],
  OverwhelmedBlush: ['*супер блаш*', '*super blush*', '*very blush*'],
  Shocked: ['*испуг*', '*scared*', '*fright*', '*shock*', '*shocked*'],
  Confusion: [
    '*расстроена*',
    '*виновато*',
    '*sad*',
    '*guilty*',
    '*удивление*',
    '*удивленно*',
    '*surprise*',
    '*amazed*'
  ],
  PensiveBlush: ['*озадачена*', '*pensive*', '*confused*', '*шепот*', '*whisper*'],
  CuteShyYes: ['*заинтересована*', '*interested*', '*curious*', '*cute*']
};

/**
 * @param {string} text
 * @returns {string|null} aggregate key или null
 */
export function findFirstAggregateEmotionKeyForDialogueLine(text) {
  const hit = explainAggregateEmotionMatch(text);
  return hit ? hit.aggregateKey : null;
}

/**
 * Какое правило сработало первым (для отладки).
 * @returns {{ aggregateKey: string, keyword: string } | null}
 */
export function explainAggregateEmotionMatch(text) {
  const lower = normalizeForDialogueEmotionTags(text).toLowerCase();
  for (const key of DIALOGUE_AGGREGATE_EMOTION_KEYS) {
    const words = DIALOGUE_AGGREGATE_EMOTION_KEYWORDS[key];
    if (!words?.length) continue;
    for (const w of words) {
      if (lower.includes(w)) return { aggregateKey: key, keyword: w };
    }
  }
  return null;
}

/** В консоли браузера: localStorage.setItem('vrDebugDialogueEmotion','1') */
export function isDialogueEmotionDebugEnabled() {
  try {
    return typeof window !== 'undefined' && window.localStorage?.getItem('vrDebugDialogueEmotion') === '1';
  } catch {
    return false;
  }
}
